import { IRaceResult} from '../../models/raceresult';

export interface IRaceResultState {
    raceResult: IRaceResult;
}

export const initialRaceResultState: IRaceResultState = {
    raceResult: null
};
